import React, { useRef } from 'react'
import { Menu, MenuList } from '@reach/menu-button'

import { KeyboardArrowDown } from 'emotion-icons/material'
import * as Styled from './Tabs.styles'
import Typography from '../Typography'

const ContentWithSelect = ({ currentData, data, setCurrentData }) => {
  const ref = useRef()
  return (
    <Styled.Wrapper className="leshen-content-with-select-wrapper">
      <Styled.GlobalStyles />
      <Menu className="menu">
        <Styled.MenuButton className="menu-button">
          {data[currentData].title}
          <span aria-hidden>
            <KeyboardArrowDown className="keyboard-arrow-down" />
          </span>
        </Styled.MenuButton>
        <MenuList className="menu-list">
          {data.map((tab, i) => (
            <Styled.MenuItem
              className="menu-item"
              key={tab.title}
              selected={i === currentData}
              onSelect={() => setCurrentData(i)}
            >
              {tab.title}
            </Styled.MenuItem>
          ))}
        </MenuList>
      </Menu>
      <Styled.InnerWrapper ref={ref} className="inner-wrapper">
        <Typography variant="h3" className="current-title">
          {data[currentData].title}
        </Typography>
        {data[currentData].content}
      </Styled.InnerWrapper>
    </Styled.Wrapper>
  )
}

export default ContentWithSelect
